import { render, staticRenderFns } from "./slcustomer-add-or-update.vue?vue&type=template&id=2bc18c9a&"
import script from "./slcustomer-add-or-update.vue?vue&type=script&lang=js&"
export * from "./slcustomer-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports